import {useNavigate} from "react-router";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-6 p-8 text-center bg-(--color-bg)">
      <div className="w-20 h-20 rounded-full bg-(--color-primary)/10 flex items-center justify-center">
        <span className="text-4xl font-bold text-(--color-primary)">404</span>
      </div>

      <div>
        <h1 className="text-2xl font-bold text-(--color-text-primary) mb-2">Página no encontrada</h1>
        <p className="text-sm text-(--color-text-secondary) max-w-md">
          La página que buscas no existe o fue movida. Verifica la URL o vuelve al dashboard.
        </p>
      </div>

      <button
        type="button"
        onClick={() => navigate("/dashboard", {replace: true})}
        className="px-6 py-2.5 text-sm font-medium rounded-md bg-(--color-primary) text-white hover:opacity-90 cursor-pointer"
      >
        Ir al Dashboard
      </button>
    </div>
  );
}
